import imagePT from "../assets/department/factory/PT.png";
import imagePV from "../assets/department/factory/PV.png";
import imageMOTOSU from "../assets/department/factory/motosu.png";
import imageKANTO from "../assets/department/factory/kantou.png";
import imageFUKUOKA from "../assets/department/factory/fukuoka.png";
import imageKUMAMOTO from "../assets/department/factory/kumamoto.png";
import imageYAI from "../assets/department/factory/yai.png";
import imageBO from "../assets/department/backoffice/backoffice.png";
import imageSite from "../assets/department/factory/site.png";
import imageAll from "../assets/department/factory/all.png";

export const VIEW_ID_ALL_FACTORY = 0;
export const VIEW_ID_PT = 50111;
export const VIEW_ID_PV = 50112;
export const VIEW_ID_54 = 54;
export const VIEW_ID_5253 = 5253;
export const VIEW_ID_SITE = 9999;
export const viewsList = [
  {
    id: VIEW_ID_ALL_FACTORY,
    category: "default",
    name: "全工場",
    image: imageAll,
  },
  {
    id: VIEW_ID_PT,
    category: "factory",
    name: "本社・屋井PT",
    image: imagePT,
  },
  {
    id: VIEW_ID_PV,
    category: "factory",
    name: "本社PV組立",
    image: imagePV,
  },
  {
    id: VIEW_ID_54,
    category: "factory",
    name: "関東工場",
    image: imageYAI,
  },
  {
    id: VIEW_ID_5253,
    category: "factory",
    name: "福岡・熊本工場",
    image: imageFUKUOKA,
  },
  {
    id: VIEW_ID_SITE,
    category: "onSite",
    name: "現場組立",
    image: imageSite,
  },
];
